import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
@Injectable()
export class SettingService {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    listByPrefix(settingName: string) {
        const params = new HttpParams().set('settingName', settingName);
        return this.http.get(`/api/setting`, { params })
            .toPromise()
    }

    fetch(section: string, refId: number, settingName: string, defaultValue: any = '') {
        const params = new HttpParams().set('defaultValue', defaultValue);
        return this.http.get(`/api/setting/${section}/${refId}/${settingName}`, { params })
            .toPromise()
    }

    config(settingName: string, defaultValue: string) {
        const params = new HttpParams().set('defaultValue', defaultValue);
        return this.http.get(`/api/setting/config/0/${settingName}`, { params })
            .toPromise()
    }

    post(data: any) {
        return this.http.post(`/api/setting`, data)
            .toPromise()
    }
}
